import {OrderDepthModels, sortDepthByPrice} from "./OrderDepthModels";

export class OrderDepthViewModel {

    private constructor(public readonly bids: OrderDepthModels,
                        public readonly totalBidVolume: number,
                        public readonly asks: OrderDepthModels,
                        public readonly totalAskVolume: number,
                        public readonly hasHiddenRows: boolean) {
    }

    public static create(bids: OrderDepthModels,
                         totalBidVolume: number,
                         asks: OrderDepthModels,
                         totalAskVolume: number,
                         hasHiddenRows: boolean): OrderDepthViewModel {
        return new OrderDepthViewModel(bids, totalBidVolume, asks, totalAskVolume, hasHiddenRows);
    }
}
